/* src/app/shared/components/overlay/overlay.component.scss */
modal-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
}
.modal-overlay.transparent {
  background-color: rgba(0, 0, 0, 0);
}
/*# sourceMappingURL=overlay.component.css.map */
